var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"id":"encours","fluid":""}},[_c('v-card-title',{staticClass:"blue darken-3"},[_c('span',{staticClass:"text-h5 white--text"},[_vm._v("Journalisation Objets")])]),[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.datas,"items-per-page":100}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }